import { createEnvelopeSource } from './create-envelope-source';

/**
 * Login-activity source over the standardized envelope
 * (`GET /analytics/login-activity`): how many people used the full app over the
 * period, how often they signed in, and the three trailing-window counts.
 *
 * Replaces `app-active-users`, which reads `last_login_at` on the account and
 * therefore keeps only the most recent login: it has to anchor on today and can
 * never trend. This reads `rctapi_user_login_days`, written at authentication
 * time, so Weekly, Daily, and Monthly anchor on the SELECTED period's end date,
 * follow the page filter, and carry a period-over-period delta.
 *
 * The RPP audience is its own source (`login-activity-rpp`), not the RPP half of
 * a split card.
 */
export const loginActivitySource = createEnvelopeSource({
    label: 'Login activity',
    endpoint: 'analytics/login-activity',
    metrics: [
        { id: 'activeUsers', label: 'Active users', type: 'scalar' },
        {
            id: 'weeklyActiveUsers',
            label: 'Weekly active users',
            type: 'scalar',
        },
        { id: 'dailyActiveUsers', label: 'Daily active users', type: 'scalar' },
        {
            id: 'monthlyActiveUsers',
            label: 'Monthly active users',
            type: 'scalar',
        },
        { id: 'logins', label: 'Logins', type: 'scalar' },
        { id: 'sessionsPerUser', label: 'Sessions per user', type: 'ratio' },
    ],
    forms: ['number', 'rate', 'bars', 'pie', 'line'],
    regionGrain: 'province',
});
